import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrl: './request-form.component.scss',
})
export class RequestFormComponent {
  interestForm: FormGroup;
  submitted = false;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private http: ApiService,
    public router: Router,
    private notify: NotificationService
  ) {
    this.interestForm = this.fb.group({
      name: ['', Validators.required],
      mobileNo: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      remarks: [''],
      consent: [0],
    });
  }

  get f() {
    return this.interestForm.controls;
  }

  submitForm() {

    this.submitted = true;

    const formValue = this.interestForm.value;

    if (this.interestForm.invalid) {
      return;
    } else {
      this.isLoading = true;
      this.http.post('retailers/saveRequestForm', formValue).subscribe({
        next: (res) => {
          if (res.code == 1) {
            this.notify.showSuccess(res.message, '');
            this.router.navigate(['/login']);
          } else {
            this.notify.showError(res.message, '');
          }
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Submission Error:', err);
          this.notify.showError('An error occurred. Please try again.', '');
        },
      });
    }
  }
}
